import React from 'react';

import  { Filter, Close, Wishlist, ChevronRight, ChevronLeft, Search } from './icons-list';


const iconComponents: { [key: string]: React.FC<React.SVGProps<SVGSVGElement>> } = {
  filter: Filter,
  close: Close,
  wishlist: Wishlist,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  search: Search,
};

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  name: string;
  width?: number;
  height?: number;
}

const Icons: React.FC<SvgIconProps> = ({ name, width = 24, height = 24, ...props }) => {
  const IconComponent = iconComponents[name];

  return IconComponent ? <IconComponent width={width} height={height} {...props} /> : <span>Icon not found</span>;
};

export default Icons;
